var _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoaderAnimation = function SvgLoaderAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 50,
    r: 10,
    fill: "#5e50fa"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: "0 0.5 0.5 1",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "10;0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    begin: "0s",
    calcMode: "discrete",
    dur: "2s",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    values: "#5e50fa;#b4adff;#978ef8;#7b70f9;#5e50fa"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 50,
    r: 10,
    fill: "#5e50fa"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    values: "0;0;10;10;10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    begin: "0s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    values: "16;16;16;50;84"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 10,
    fill: "#7b70f9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "-0.5s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    values: "0;0;10;10;10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    begin: "-0.5s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    values: "16;16;16;50;84"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 50,
    r: 10,
    fill: "#978ef8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "-1s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    values: "0;0;10;10;10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    begin: "-1s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    values: "16;16;16;50;84"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 50,
    r: 10,
    fill: "#b4adff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "-1.5s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    values: "0;0;10;10;10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    begin: "-1.5s",
    calcMode: "spline",
    dur: "2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.25;0.5;0.75;1",
    repeatCount: "indefinite",
    values: "16;16;16;50;84"
  }))));
};
export default SvgLoaderAnimation;